// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"501":"component---src-pages-contact-js","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"501":"2c46937d9e35e8870503","678":"f25a683bb95503f38bb9","682":"e7c91a58a33adaea0b92"}[chunkId] + ".js";
};